import * as Icon from "react-bootstrap-icons";
import dayjs from "dayjs";
import axios from "axios";
import { useState, useEffect } from "react";
import { API_URL } from "../../data/constants";

export default function WorksheetItem({worksheet,
                                       setSelectedItem
                                      }) {
    useEffect(() => {
        setSelectedItem(Math.random());
    });
    
  return (
      <div className={`statement-item`}>
        <div className="statement-item-wrapper">
          <div className="statement-info">
            <p className="font-weight-bold">{`${dayjs(worksheet.accountingMonth).format("MMM D, YYYY")}`}</p>
          </div>
          <div className="statement-item-select">
            <p
                className="statement-item-download"
                onClick={() => {
                  axios
                      .post(
                          API_URL + "/Statements/GetWorksheetPDF",
                          {
                              worksheetId: worksheet.interruptibleWorksheetId
                          },
                          {
                            headers: {
                              Authorization: localStorage.getItem("accessToken"),
                            },
                          }
                      )
                      .then((res) => {
                        const base64 = res.data.pdf.split(",")[1];
                        const bytes = window
                            .atob(base64)
                            .split("")
                            .map((c) => c.charCodeAt(0));
                        const file = new Blob([new Uint8Array(bytes)], {
                          type: "application/pdf",
                        });
                        const fileURL = URL.createObjectURL(file);
                        const pdfWindow = window.open();
                        pdfWindow.location.href = fileURL;
                      })
                      .catch((error) => {
                        console.error(error);
                      });
                }}>
              Download PDF &nbsp;
              <Icon.FilePdf height={24} width={24} />
            </p>
          </div>
        </div>
      </div>
  );
}
